import * as React from 'react';
import CourtReporting939importExportCore from './CourtReporting939ImportExportCore';
import { UserRoleEnum } from '../../redux/UserSlice';




const CourtReporting939ImportExport = (props: any) => {

    return (
        <React.Fragment>
            <CourtReporting939importExportCore userRole={UserRoleEnum.EntityUser} />
        </React.Fragment>
    );
}

export default CourtReporting939ImportExport;